import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ampli } from '../../../ampli';

export const useCatchQueryString = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.search) {
      const urlParams = new URLSearchParams(location.search);

      // AB테스트에 대한 Query String 체크 => 테스트 내용을 amplitude에 기록
      if (urlParams.has('abt')) {
        ampli.기타운영Ab테스트({
          '테스트 내용': urlParams.get('abt')!.trim(),
        });
      }

      // 유저 정보
      if (urlParams.has('tm')) {
        ampli.기타운영유저정보({
          '전화 번호': Number(urlParams.get('tm')!.trim()) / 55,
        });
      }
    }
  }, [navigate, location.pathname, location.search]);
};
